import CryptoJS from 'crypto-js';
import type { Bit } from './quantumService';

export class EncryptionService {
  static formatKeyForAES(rawBits: Bit[]): string {
    let targetBits = [...rawBits];

    if (targetBits.length > 256) {
      targetBits = targetBits.slice(0, 256);
    }
    while (targetBits.length < 256) {
      targetBits.push(0);
    }

    let hexString = '';
    for (let i = 0; i < targetBits.length; i += 4) {
      const chunk = targetBits.slice(i, i + 4).join('');
      const hexChar = parseInt(chunk, 2).toString(16);
      hexString += hexChar;
    }

    return hexString;
  }

  static bitsToHex(bits: Bit[]): string {
    return this.formatKeyForAES(bits);
  }

  static encrypt(plaintext: string, keyHex: string): string {
    try {
      const key = CryptoJS.enc.Hex.parse(keyHex);
      const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    } catch (error) {
      console.error('Encryption Error:', error);
      return '';
    }
  }

  static decrypt(ciphertext: string, keyHex: string): string | null {
    try {
      const key = CryptoJS.enc.Hex.parse(keyHex);
      const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
      if (!plaintext) {
        throw new Error('Empty decryption result');
      }

      return plaintext;
    } catch (error) {
      return '🚨 Decryption Error: Key mismatch or tampered data.';
    }
  }

  static generateIV(): string {
    return CryptoJS.lib.WordArray.random(128 / 8).toString();
  }
}
